<sub-nav [menu]="menu"></sub-nav>
<date-menu></date-menu>
<div class="container-fluid datenav-padding">
  <router-outlet></router-outlet>
</div>
